import { detectPortal, Portal } from './common/util/detect-portal';
import { Environment, getEnvironment } from './common/util/environment';

const portal = detectPortal();

if (portal === Portal.SPP) {
    const { bootstrap } = await import('./spp/bootstrap');
    await bootstrap();
} else if (portal === Portal.TEST_GEN && getEnvironment() !== Environment.PRODUCTION) {
    const { bootstrap } = await import('./test_gen/bootstrap');
    await bootstrap();
} else {
    const { bootstrap } = await import('./cpp/bootstrap');
    await bootstrap();
}
